<template>
  <div>
    <div class="text-center company-info pa-4 grey--text" color="grey darken-4">
      <div
        elevation="5"
        class="company-logo grey lighten-2 ma-3"
        style="
          border: 1px solid #333;
          display: inline-block;
          width: 150px;
          height: 150px;
        "
      >
        <v-img
          v-if="this.companyInfo.logo"
          max-height="150"
          max-width="150"
          :src="this.companyInfo.logo"
          to="dashboard"
          lazy-src="@/img/defaultcompanylogo.png"
          contain
          style="margin: 0; padding: 0; margin-right: 5px"
        ></v-img>

        <v-img
          v-if="!this.companyInfo.logo"
          max-height="150"
          max-width="150"
          src="@/img/defaultcompanylogo.png"
          to="dashboard"
          lazy-src="@/img/defaultcompanylogo.png"
          contain
          style="margin: 0; padding: 0; margin-right: 5px"
        ></v-img>
      </div>
      <h3
        id="side-company-name"
        style="color: #333"
        color="grey--text darken-4"
      >
        {{ this.companyInfo.ragioneSociale }}
      </h3>
    </div>
    <v-divider style="background: #cf1818"></v-divider>
    <v-list>
      <v-list-item :to="{ name: 'dashboard' }" active-class="active">
        <v-list-item-icon><v-icon>mdi-view-dashboard</v-icon></v-list-item-icon>
        <v-list-item-title>Dashboard</v-list-item-title>
      </v-list-item>

      <v-list-group
        prepend-icon="mdi-calendar"
        active-class="active"
        dense
        v-if="
          !plannerDisabled ||
          !plannerEquipmentsDisabled ||
          !plannerVehiclesDisabled ||
          !abcenceRequestsDisabled
        "
      >
        <template v-slot:activator>
          <v-list-item-title> Pianificazione</v-list-item-title>
        </template>
        <v-list-item
          dense
          v-if="!abcenceRequestsDisabled"
          :to="{ name: 'permissions-requests' }"
          active-class="active"
        >
          <v-list-item-title>Richieste permessi</v-list-item-title>
        </v-list-item>
        <v-list-item
          dense
          :to="{ name: 'plan' }"
          v-if="!plannerDisabled"
          active-class="active"
        >
          <v-list-item-title>Pianifica Interventi</v-list-item-title>
        </v-list-item>
        <v-list-item
          dense
          :to="{ name: 'plan-equipments' }"
          v-if="!plannerEquipmentsDisabled"
          active-class="active"
        >
          <v-list-item-title>Pianifica Attrezzature</v-list-item-title>
        </v-list-item>

        <v-list-item
          dense
          :to="{ name: 'plan-vehicles' }"
          v-if="!plannerVehiclesDisabled"
          active-class="active"
        >
          <v-list-item-title>Pianifica Mezzi</v-list-item-title>
        </v-list-item>
      </v-list-group>
      <v-list-group
        prepend-icon="mdi-calendar-multiselect"
        v-if="
          !plannerViewDisabled || !TodayViewDisabled || !TomorrowViewDisabled
        "
        active-class="active"
      >
        <template v-slot:activator>
          <v-list-item-title>Riepilogo interventi</v-list-item-title>
          <!-- <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>-->
        </template>

        <v-list-item
          dense
          active-class="active"
          v-if="!plannerViewDisabled"
          :target="'_blank'"
          :to="{
            name: 'plan-viewer',
            query: {
              type: 'All',
              speed: UISettings.plannerViewer.scrollerSpeed,
            },
          }"
        >
          <v-list-item-title>Visualizza pianificazione</v-list-item-title>
        </v-list-item>
        <v-list-item
          dense
          active-class="active"
          v-if="!plannerViewDisabled"
          :target="'_blank'"
          :to="{
            name: 'plan-viewer',
            query: {
              type: 'Mezzo',
              speed: UISettings.planner.scrollerSpeed,
            },
          }"
        >
          <v-list-item-title>Visualizza pianificazione mezzi</v-list-item-title>
        </v-list-item>
        <v-list-item
          dense
          active-class="active"
          v-if="!plannerViewDisabled"
          :target="'_blank'"
          :to="{
            name: 'plan-viewer',
            query: {
              type: 'Attrezzatura',
              speed: UISettings.planner.scrollerSpeed,
            },
          }"
        >
          <v-list-item-title
            >Visualizza pianificazione attrezzature</v-list-item-title
          >
        </v-list-item>
        <v-list-item
          dense
          active-class="active"
          v-if="!TodayViewDisabled"
          :target="'_blank'"
          :to="{
            name: 'event-viewer',
            query: { date: moment(new Date()).format('MM/DD/YYYY') },
          }"
        >
          <v-list-item-title>Eventi di oggi</v-list-item-title>
        </v-list-item>
        <v-list-item
          dense
          active-class="active"
          v-if="!TomorrowViewDisabled"
          :target="'_blank'"
          :to="{
            name: 'event-viewer',
            query: {
              date: moment(addDays(new Date(), 1)).format('MM/DD/YYYY'),
            },
          }"
        >
          <v-list-item-title>Eventi di domani</v-list-item-title>
        </v-list-item>
      </v-list-group>
      <v-list-group
        active-class="active"
        prepend-icon="mdi-archive"
        v-if="
          !manageUsersDisabled ||
          !manageCustomersDisabled ||
          !manageResourcesDisabled
        "
      >
        <template v-slot:activator>
          <v-list-item-title>Archivi</v-list-item-title>
          <!-- <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>-->
        </template>
        <v-list-item
          dense
          active-class="active"
          v-if="!manageOrdersDisabled"
          :to="{ name: 'manage-orders' }"
        >
          <v-list-item-title>Commesse</v-list-item-title>
        </v-list-item>

        <v-list-item
          dense
          active-class="active"
          v-if="!manageCustomersDisabled"
          :to="{ name: 'manage-customers' }"
        >
          <v-list-item-title>Clienti</v-list-item-title>
        </v-list-item>
        <v-list-item
          dense
          active-class="active"
          v-if="!manageUsersDisabled"
          :to="{ name: 'manage-users' }"
        >
          <v-list-item-title>Utenti</v-list-item-title>
        </v-list-item>
        <v-list-item
          dense
          active-class="active"
          v-if="!manageResourcesDisabled"
          :to="{ name: 'manage-workers' }"
        >
          <v-list-item-title>Risorse</v-list-item-title>
        </v-list-item>
      </v-list-group>
      <v-list-group
        prepend-icon="mdi-cogs"
        active-class="active"
        v-if="!managePermissionsDisabled || !editCompanyDisabled"
      >
        <template v-slot:activator>
          <v-list-item-title>Strumenti di amministrazione</v-list-item-title>
          <!-- <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>-->
        </template>

        <v-list-item
          dense
          active-class="active"
          v-if="!managePermissionsDisabled"
          :to="{ name: 'manage-roles' }"
        >
          <v-list-item-title>Gestione permessi</v-list-item-title>
        </v-list-item>
        <v-list-item
          dense
          active-class="active"
          v-if="!editCompanyDisabled"
          :to="{ name: 'company-edit' }"
        >
          <v-list-item-title>Modifica azienda</v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-list>
    <!-- <v-list dense nav>
      <v-list-item
        v-for="item in items.filter((item) => !item.hide)"
        :key="item.title"
        :to="item.value"
      >
        <v-list-item-icon>
          <v-img :src="item.icon" height="25px" width="10px"></v-img>

           <v-icon>{{ item.icon }}</v-icon> -->
    <!-- </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list> -->
    <!-- v-bind:color="
              currentUser.colore != null ? currentUser.colore : '#777'
            " -->
  </div>
</template>

<style lang="scss">
#sidebar-logo {
  display: flex;
  margin: 15px;
}
.v-list-item.active {
  color: #d43535 !important;
}
.v-list-group.active {
  color: #d43535 !important;
}
a.v-list-item.v-list-item--dense.v-list-item--link.theme--light {
  border-left: 1px solid #d43535;
  margin-left: 25px;
  padding-bottom: 0px;
}

.theme--light.v-list-item:not(.v-list-item--active):not(
    .v-list-item--disabled
  ) {
  color: rgb(46, 46, 46) !important;
}
</style>

<script>
import UISettingsHelper from "../../utils/UISettingsHelper";
import SessionHelper from "../../utils/SessionHelper";

import moment from "moment";
export default {
  mounted() {
    this.initMenu();
  },
  data() {
    let alias = this.$route.params.companyAlias;
    let date = new Date();

    let today = "m%2Fd%2FY"
      .replace("Y", date.getFullYear())
      .replace("m", date.getMonth() + 1)
      .replace("d", date.getDate());

    let tomorrow = "m%2Fd%2FY"
      .replace("Y", date.getFullYear())
      .replace("m", date.getMonth() + 1)
      .replace("d", date.getDate() + 1);

    return {
      items: [],
      right: null,
      moment: moment,
    };
  },
  computed: {
    UISettings() {
      UISettingsHelper.LoadSettings();
      return UISettingsHelper.GetSettings();
    },
    companyInfo() {
      if (localStorage.companyInfo != null)
        return JSON.parse(localStorage.companyInfo);
      else return { ragioneSociale: "---" };
    },
    abcenceRequestsDisabled() {
      return !(
        SessionHelper.checkPermission("APPROVA_ASSENZE") &&
        SessionHelper.checkPermission("EVENTS_READ")  
      );
    },
    plannerViewDisabled() {
      return !(
        SessionHelper.checkPermission("USERS_READ") &&
        SessionHelper.checkPermission("EVENTS_READ") &&
        SessionHelper.checkPermission("CUSTOMERS_READ")
      );
    },

    TodayViewDisabled() {
      return !(
        SessionHelper.checkPermission("USERS_READ") &&
        SessionHelper.checkPermission("EVENTS_READ") &&
        SessionHelper.checkPermission("CUSTOMERS_READ")
      );
    },

    TomorrowViewDisabled() {
      return !(
        SessionHelper.checkPermission("USERS_READ") &&
        SessionHelper.checkPermission("EVENTS_READ") &&
        SessionHelper.checkPermission("CUSTOMERS_READ")
      );
    },

    plannerDisabled() {
      return !(
        SessionHelper.checkPermission("EVENTS_READ") &&
        SessionHelper.checkPermission("EVENT_UPDATE") &&
        SessionHelper.checkPermission("EVENT_INSERT")
      );
    },

    plannerVehiclesDisabled() {
      return !(
        SessionHelper.checkPermission("EVENTS_READ") &&
        SessionHelper.checkPermission("EVENT_UPDATE") &&
        SessionHelper.checkPermission("EVENT_INSERT")
      );
    },
    plannerEquipmentsDisabled() {
      return !(
        SessionHelper.checkPermission("EVENTS_READ") &&
        SessionHelper.checkPermission("EVENT_UPDATE") &&
        SessionHelper.checkPermission("EVENT_INSERT")
      );
    },
    manageUsersDisabled() {
      return !SessionHelper.checkPermission("USERS_READ");
    },
    manageOrdersDisabled() {
      return !SessionHelper.checkPermission("ORDERS_READ");
    },

    manageResourcesDisabled() {
      return !(
        SessionHelper.checkPermission("RESOURCES_READ") &&
        SessionHelper.checkPermission("USERS_READ") &&
        SessionHelper.checkPermission("EVENTS_READ")
      );
    },
    manageCustomersDisabled() {
      return !SessionHelper.checkPermission("CUSTOMERS_READ");
    },

    managePermissionsDisabled() {
      return !SessionHelper.checkPermission("ROLES_READ");
    },

    editCompanyDisabled() {
      return !SessionHelper.checkPermission("COMPANY_UPDATE");
    },

    planVehiclesDisabled() {
      return !(
        SessionHelper.checkPermission("RESOURCES_READ") &&
        SessionHelper.checkPermission("USERS_READ") &&
        SessionHelper.checkPermission("EVENTS_READ")
      );
    },

    planEquipmentDisabled() {
      return !(
        SessionHelper.checkPermission("RESOURCES_READ") &&
        SessionHelper.checkPermission("USERS_READ") &&
        SessionHelper.checkPermission("EVENTS_READ")
      );
    },
  },
  methods: {
    addDays(date, days) {
      date.setDate(date.getDate() + days);
      return date;
    },
    initMenu() {
      let alias = this.$route.params.companyAlias;
      let date = new Date();

      let today = "m%2Fd%2FY"
        .replace("Y", date.getFullYear())
        .replace("m", date.getMonth() + 1)
        .replace("d", date.getDate());

      let tomorrow = "m%2Fd%2FY"
        .replace("Y", date.getFullYear())
        .replace("m", date.getMonth() + 1)
        .replace("d", date.getDate() + 1);

      let items = [
        {
          title: "Dashboard",
          icon: require("../../img/dashboard.png"),
          value: `/${alias}/dashboard`,
          hide: false,
        },
        {
          title: "Pianifica Interventi",
          icon: require("../../img/interventi.png"),
          value: `/${alias}/plan`,
          hide: this.plannerDisabled,
        },
        {
          title: "Pianifica Attrezzature",
          icon: require("../../img/attrezzature.png"),
          value: `/${alias}/Plan/Equipments`,
          hide: this.planEquipmentDisabled,
        },
        {
          title: "Pianifica Mezzi",
          icon: require("../../img/mezzi.png"),
          value: `/${alias}/Plan/Vehicles`,
          hide: this.planVehiclesDisabled,
        },
        {
          title: "Visualizza Pianificazione",
          icon: require("../../img/calendar.png"),
          value: `/${alias}/Planner/Viewer`,

          hide: this.plannerViewDisabled,
        },
        {
          title: "Eventi di Oggi",
          icon: require("../../img/oggi.png"),
          value: `/${alias}/EventViewer?date=${today}`,
          hide: this.plannerViewDisabled,
        },
        {
          title: "Eventi di Domani",
          icon: require("../../img/eventsTomorrow.png"),
          value: `/${alias}/EventViewer?date=${tomorrow}`,
          hide: this.plannerViewDisabled,
        },
        {
          title: "Gestione Permessi",
          icon: require("../../img/permission.png"),
          value: `/${alias}/Roles`,
          hide: this.managePermissionsDisabled,
        },
        {
          title: "Gestione Risorse",
          icon: require("../../img/risorse.png"),
          value: `/${alias}/Workers`,
          hide: this.manageResourcesDisabled,
        },
        {
          title: "Gestione Utenti",
          icon: require("../../img/utenti.png"),
          value: `/${alias}/Users`,
          hide: this.manageUsersDisabled,
        },
        {
          title: "Gestione Clienti",
          icon: require("../../img/clienti.png"),
          value: `/${alias}/Customers`,
          hide: this.manageCustomersDisabled,
        },
        {
          title: "Modifica Dati Azienda",
          icon: require("../../img/companydata.png"),
          value: `/${alias}/Edit`,
          hide: this.editCompanyDisabled,
        },
      ];
      this.items = items;
    },
    logout() {
      SessionHelper.Logoff(this.$route.params.companyAlias);
    },
  },
};
</script>
